__turbopack_context__.v({
  "fade-in-u0abkuy": "worksList-module-scss-module__jpOBHa__fade-in-u0abkuy",
  "report": "worksList-module-scss-module__jpOBHa__report",
  "work-list": "worksList-module-scss-module__jpOBHa__work-list",
  "work-list-header": "worksList-module-scss-module__jpOBHa__work-list-header",
  "wrapper": "worksList-module-scss-module__jpOBHa__wrapper",
});
